import React from 'react';
import styled from 'styled-components';
import FeaturedStarBadge from 'assets/booths/featured-star.svg';

const FeaturedStarContainer = styled.div`
  position: relative;
`;

const FeaturedStarImage = styled.img`
  position: absolute;
  top: -165px;
  left: -390px;
  border-top-left-radius: 8px;

  @media (max-width: 959px) {
    top: -140px;
    left: -360px;
  }
`;

const FeaturedStar = () => (
  <FeaturedStarContainer>
    <FeaturedStarImage src={FeaturedStarBadge} alt="Featured Booth" />
  </FeaturedStarContainer>
);

export default FeaturedStar;
